import { render, staticRenderFns } from "./sandBoxDetail.vue?vue&type=template&id=658ae894&scoped=true&"
import script from "./sandBoxDetail.vue?vue&type=script&lang=js&"
export * from "./sandBoxDetail.vue?vue&type=script&lang=js&"
import style0 from "./sandBoxDetail.vue?vue&type=style&index=0&id=658ae894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ae894",
  null
  
)

export default component.exports